(function () {
  function initSwipe(container) {
    var track      = container.querySelector('.grid-product__swipe-track');
    var dots       = container.querySelectorAll('.swipe-dot');
    var total      = parseInt(container.getAttribute('data-swipe-count'), 10);
    var productUrl = container.getAttribute('data-swipe-url');
    if (!track || total <= 1) return;

    var current  = 0;
    var startX   = 0;
    var startY   = 0;
    var isHoriz  = null;
    var didSwipe = false;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      var w = container.offsetWidth;
      track.style.transform = 'translateX(-' + (current * w) + 'px)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('swipe-dot--active', i === current);
      });
    }

    container.addEventListener('touchstart', function (e) {
      startX   = e.touches[0].clientX;
      startY   = e.touches[0].clientY;
      isHoriz  = null;
      didSwipe = false;
    }, { passive: true });

    container.addEventListener('touchmove', function (e) {
      if (isHoriz === null) {
        var dx = Math.abs(e.touches[0].clientX - startX);
        var dy = Math.abs(e.touches[0].clientY - startY);
        if (dx > 5 || dy > 5) isHoriz = dx > dy;
      }
      if (isHoriz) e.preventDefault();
    }, { passive: false });

    container.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (isHoriz && Math.abs(diff) > 30) {
        goTo(diff > 0 ? current + 1 : current - 1);
        didSwipe = true;
      }
      isHoriz = null;
    }, { passive: true });

    // The link overlay (grid-product__link:after z-index:1) is below us (z-index:2).
    // A tap (no swipe) must still navigate to the product page.
    container.addEventListener('click', function () {
      if (!didSwipe && productUrl) window.location.href = productUrl;
      didSwipe = false;
    });
  }

  function init() {
    document.querySelectorAll('.js-swipe-container').forEach(initSwipe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
